import axiosInstance from "./axiosConfig";

const API_URL = "/api/payments";

const getAllPayments = async (filters = {}) => {
  // Filters can include: status, method, startDate, endDate, patientName
  const response = await axiosInstance.get(API_URL, { params: filters });
  return response.data;
};

const getPaymentById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/${id}`);
  return response.data;
};

const updatePayment = async (id, paymentData) => {
  const response = await axiosInstance.put(`${API_URL}/${id}`, paymentData);
  return response.data;
};

const deletePayment = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/${id}`);
  return response.data;
};

const exportPaymentsPdf = async (filters = {}) => {
  const response = await axiosInstance.get(`${API_URL}/export/pdf`, {
    params: filters,
    responseType: "blob",
  });
  return response.data;
};

const getPaymentSummary = async () => {
  const response = await axiosInstance.get(`${API_URL}/summary`);
  return response.data;
};

const paymentService = {
  getAllPayments,
  getPaymentById,
  updatePayment,
  deletePayment,
  exportPaymentsPdf,
  getPaymentSummary,
};

export default paymentService;
